module.exports = __webpack_public_path__ + "static/media/1. Primavera, Resina cristal, 65 x 70 cm aproximado, 2020 copy.f44821cc.png";